import { useState, useEffect } from 'react';

export const useCurrentURI = () => {
  const [currentURI, setCurrentURI] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCurrentURI(window.location.pathname);
    }
  }, []);

  return currentURI;
};

export const useCurrentSlug = () => {
  const [currentSlug, setCurrentSlug] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const segments = window.location.pathname.split('/').filter(segment => segment);
      setCurrentSlug(segments.length > 0 ? `/${segments[segments.length - 1]}/` : '');
    }
  }, []);

  return currentSlug;
};
